import React from 'react';
interface AuthLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
}
const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  title = 'SubTracker',
  subtitle = 'Manage all your subscriptions in one place'
}) => {
  return <div className="min-h-screen flex flex-col md:flex-row" data-id="element-33">
      {/* Content Side */}
      <div className="w-full md:w-3/5 lg:w-1/2 flex items-center justify-center p-6 md:p-10 lg:p-16 bg-white" data-id="element-34">
        <div className="w-full max-w-md lg:max-w-lg" data-id="element-35">
          <h1 className="text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-teal-600" data-id="element-36">
            {title}
          </h1>
          {children}
        </div>
      </div>
      {/* Visual Side */}
      <div className="hidden md:flex w-2/5 lg:w-1/2 bg-gradient-to-br from-teal-600 to-teal-800 relative overflow-hidden" data-id="element-37">
        <div className="absolute inset-0 opacity-10" data-id="element-38">
          <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" data-id="element-39">
            <defs data-id="element-40">
              <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse" data-id="element-41">
                <path d="M 10 0 L 0 0 0 10" fill="none" stroke="white" strokeWidth="0.5" data-id="element-42" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" data-id="element-43" />
          </svg>
        </div>
        <div className="relative z-10 flex flex-col items-center justify-center w-full h-full p-12 text-white" data-id="element-44">
          <div className="rounded-full bg-white/10 p-6 backdrop-blur-sm mb-8" data-id="element-45">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-46">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2" data-id="element-47"></rect>
              <line x1="16" y1="2" x2="16" y2="6" data-id="element-48"></line>
              <line x1="8" y1="2" x2="8" y2="6" data-id="element-49"></line>
              <line x1="3" y1="10" x2="21" y2="10" data-id="element-50"></line>
              <path d="M8 14h.01" data-id="element-51"></path>
              <path d="M12 14h.01" data-id="element-52"></path>
              <path d="M16 14h.01" data-id="element-53"></path>
              <path d="M8 18h.01" data-id="element-54"></path>
              <path d="M12 18h.01" data-id="element-55"></path>
              <path d="M16 18h.01" data-id="element-56"></path>
            </svg>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-center" data-id="element-57">
            {subtitle}
          </h2>
          <p className="text-xl text-center max-w-md opacity-80" data-id="element-58">
            Track, manage, and optimize your recurring payments all in one
            dashboard.
          </p>
          <div className="mt-12 grid grid-cols-2 gap-6 w-full max-w-md" data-id="element-59">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4" data-id="element-60">
              <h3 className="font-semibold text-xl mb-1" data-id="element-61">Easy Tracking</h3>
              <p className="text-white/80 text-sm" data-id="element-62">
                Monitor all your subscriptions in one place
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4" data-id="element-63">
              <h3 className="font-semibold text-xl mb-1" data-id="element-64">Save Money</h3>
              <p className="text-white/80 text-sm" data-id="element-65">
                Identify unused services and reduce expenses
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4" data-id="element-66">
              <h3 className="font-semibold text-xl mb-1" data-id="element-67">Reminders</h3>
              <p className="text-white/80 text-sm" data-id="element-68">
                Never miss a payment deadline again
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4" data-id="element-69">
              <h3 className="font-semibold text-xl mb-1" data-id="element-70">Insights</h3>
              <p className="text-white/80 text-sm" data-id="element-71">
                Visualize spending patterns and trends
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default AuthLayout;